import React from "react";
import GlobalContext from "./GlobalContext";

function Error(){
  const global = React.useContext(GlobalContext);

  if(!global.state.error) return false;

  return <div className="error">{ global.state.errorMessage }</div>;
}

export default Error;